module.exports = __webpack_public_path__ + "img/passport-2.49b62f36.png";